import api from './api';
import { LoginAttemptResponse, LoginResponse, TwoFactorSetupResponse } from '../types';

interface ChangePasswordResponse {
  message: string;
}

interface ForgotPasswordResponse {
  message: string;
}

interface ResetPasswordResponse {
  message: string;
}

interface SwitchTenantResponse {
  token: string;
  refreshToken: string;
  expiration: string;
  username: string;
  roles: string[];
  tenantId?: number;
  tenantCode?: string;
  tenantName?: string;
}

const authService = {
  login: async (username: string, password: string): Promise<LoginAttemptResponse> => {
    const response = await api.post<LoginAttemptResponse>('/api/auth/login', { username, password });
    return response.data;
  },

  loginWithTwoFactor: async (challengeToken: string, code: string): Promise<LoginResponse> => {
    const body = challengeToken && challengeToken !== 'cookie'
      ? { challengeToken, code }
      : { code };
    const response = await api.post<LoginResponse>('/api/auth/login/twofactor', body);
    return response.data;
  },

  setupTwoFactor: async (): Promise<TwoFactorSetupResponse> => {
    const response = await api.post<TwoFactorSetupResponse>('/api/auth/twofactor/setup');
    return response.data;
  },

  enableTwoFactor: async (code: string): Promise<void> => {
    await api.post('/api/auth/twofactor/enable', { code });
  },

  disableTwoFactor: async (currentPassword: string, code: string): Promise<void> => {
    await api.post('/api/auth/twofactor/disable', { currentPassword, code });
  },

  switchTenant: async (tenantId: number): Promise<SwitchTenantResponse> => {
    const response = await api.post<SwitchTenantResponse>('/api/auth/switchtenant', { tenantId });
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<ChangePasswordResponse> => {
    const response = await api.post<ChangePasswordResponse>('/api/auth/changepassword', {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  forgotPassword: async (username: string): Promise<ForgotPasswordResponse> => {
    const response = await api.post<ForgotPasswordResponse>('/api/auth/forgotpassword', {
      username
    });
    return response.data;
  },

  resetPassword: async (token: string, newPassword: string): Promise<ResetPasswordResponse> => {
    const response = await api.post<ResetPasswordResponse>('/api/auth/resetpassword', {
      token,
      newPassword
    });
    return response.data;
  }
};

export default authService;
